import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getCampaignHomePath } from '../campaign/uob-sbf-2026';
import { accessAuthState } from '../states/auth.state';

interface PrivateRoute {
  path: string;
  exact?: boolean;
  showLogin?: boolean;
  component: any;
  roles?: any;
}

export const PrivateRoute = (props: PrivateRoute) => {
  const { component: Component, roles, showLogin, ...rest } = props

  return (
    <Route {...rest} render={props => {
      const authState = accessAuthState()

      if (!authState.isLoggedIn) {
        // Keep campaign home when session is active (avoid wiping via public /)
        return <Redirect to={{
          pathname: getCampaignHomePath(),
          search: `${showLogin ? '?action=login' : ''}`,
          state: { from: props.location },
        }} />
      }

      // authorised so return component
      return <Component {...props} />
    }} />
  )
}
